// Add some basic styling
// Note: Most styling is handled by Tailwind and design tokens in components.
// This file provides minimal base styles for field wrappers.
const styles = `
.field-wrapper {
    margin-bottom: 16px;
}

.field-wrapper label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
}

.field-wrapper .help-text {
    margin-top: 4px;
    font-size: 12px;
}
`;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);
